// extracted by mini-css-extract-plugin
module.exports = {"blue300":"#14267B","acceptBox":"UserInfoForm_acceptBox__u4F9q","acceptBoxCheckbox":"UserInfoForm_acceptBoxCheckbox__b53Sm","acceptBoxLink":"UserInfoForm_acceptBoxLink__gXRJD"};